import { Sidebar, SidebarContent, useIsMobile } from "@elit-hair/elit-ui";

import { DarwinAI } from "@/components/ai-chat";

import { RightSidebarResizeHandle } from "./right-sidebar-resize-handle";

type SidebarRightProps = {
    onWidthChange: (widthPx: number | null) => void;
};

export function SidebarRight({ onWidthChange }: SidebarRightProps) {
    const isMobile = useIsMobile();

    return (
        <Sidebar side="right" variant="inset" collapsible="offcanvas">
            <SidebarContent className="relative h-full overflow-hidden p-2 pr-2">
                {!isMobile && <RightSidebarResizeHandle onWidthChange={onWidthChange} />}
                <DarwinAI />
            </SidebarContent>
        </Sidebar>
    );
}
